/** Public site logo — served from /public/logo.png (not inlined in bundle/HTML). */
export const LOGO_SRC = '/logo.png';
